import { createRouter, createWebHistory } from 'vue-router'

import HomepageView from '@/views/HomepageView.vue'
import ErrorView from '@/views/ErrorView'
import GdprView from '@/views/GdprView'
import FaqView from '@/views/FaqView'
import AboutUsView from '@/views/AboutUsView'
import ConstructionView from '@/views/ConstructionView'
import AboutProjectView from '@/views/AboutProjectView'
import ComplianceView from '@/views/ComplianceView'
import ContactUsView from '@/views/ContactUsView'
import AnnouncementsView from '@/views/AnnouncementsView'
import DocumentsView from '@/views/DocumentsView'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomepageView
    },
    {
        path: '/about',
        name: 'about',
        component: AboutUsView
    },
    {
        path: '/construction',
        name: 'construction',
        component: ConstructionView
    },
    {
        path: '/about-project',
        name: 'aboutProject',
        component: AboutProjectView
    },
    {
        path: '/compliance',
        name: 'compliance',
        component: ComplianceView
    },
    {
        path: '/documents',
        name: 'documents',
        component: DocumentsView
    },
    {
        path: '/contact',
        name: 'contact',
        component: ContactUsView
    },
    {
        path: '/faq',
        name: 'faq',
        component: FaqView
    },
    {
        path: '/announcements',
        name: 'announcements',
        component: AnnouncementsView
    },
    {
        path: '/website-terms-conditions',
        name: 'website-terms-conditions',
        component: GdprView
    },
    {
        path: '/:catchAll(.*)',
        component: ErrorView
    },
]

const router = createRouter({
    // Route base: the site is served from the root. If the Swedish project ever
    // needs a URL prefix (as the US site does with /kingstreewest/), set it here
    // and keep it separate from the asset publicPath ('/') in vue.config.js,
    // because the host serves the build from the site root with SPA fallback
    // to index.html.
    history: createWebHistory('/'),
    routes,
})

export default router;
